import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import HelpIcon from "@mui/icons-material/Help";
import React, {useCallback, useMemo} from "react";
import './list.css'
import { useLoggedInArtistLocale } from "../../hooks/useLoggedInArtistLocale";
import { getLocalizedHelpUrl } from "../../models/help";

const ListDialogContainer = ({onExit, children, header, isFullView, helpLink}) => {
    const [visible, setVisible] = React.useState(true)
    const locale = useLoggedInArtistLocale()
    const localizedHelpLink = useMemo(() => helpLink ? getLocalizedHelpUrl(helpLink, locale) : null, [helpLink, locale])

    const handleOpenHelp = useCallback(() => window.open(localizedHelpLink, '_blank'), [localizedHelpLink])

    const handleExit = useCallback(() => {
        setVisible(false)
        onExit()
    }, [onExit, setVisible])

    return (
        (<Fade in={visible} timeout={500}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    bgcolor: "background.default",
                    color: "text.primary"
                }}>
                {!isFullView ? <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h4" component="span"
                                    sx={{
                                        color: "text.primary"
                                    }}>{header}</Typography>
                        {helpLink ? <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenHelp}
                        >
                            <HelpIcon/>
                        </IconButton> : null}
                        <Box sx={{
                            flexGrow: 1
                        }}></Box>
                        <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleExit}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </Toolbar>
                </AppBar> : null}
                <Fade in={visible} timeout={1000}>
                    <Box sx={{flex: 1, display: "flex", flexDirection: "column", minHeight: 0, padding: "0 2em"}}>
                        {visible ? children : null}
                    </Box>
                </Fade>
            </Box>
        </Fade>)
    );
};

export default ListDialogContainer;
